import { inject, Injectable } from "@angular/core";
import { PlatformTypes, ProvisioningPlatform, ProvisioningTargetDto } from "@app/models";
import { PlatformAccountService } from "@app/services/platform-account.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AdvancedAccountSetupStatusProvider,
  AdvancedAccountSetupTarget,
  AdvancedAccountStatus
} from "../types/advanced-account-setup.types";

@Injectable({ providedIn: "root" })
export class AdvancedAccountSetupStatusApiProvider implements AdvancedAccountSetupStatusProvider {
  private readonly platformAccountService = inject(PlatformAccountService);

  getStatus(target: AdvancedAccountSetupTarget): Observable<AdvancedAccountStatus> {
    return this.platformAccountService.getProvisioningStatus(this.toDto(target)).pipe(map(({ status }) => AdvancedAccountStatus[status]));
  }

  retry(target: AdvancedAccountSetupTarget): Observable<unknown> {
    return this.platformAccountService.retryProvisioning(this.toDto(target));
  }

  private toDto(target: AdvancedAccountSetupTarget): ProvisioningTargetDto {
    return target.kind === "platform"
      ? { platformId: PlatformTypes[target.platform] as ProvisioningPlatform }
      : { widgetTypeSettingsId: target.widgetType };
  }
}
